import angular from 'angular';
import stPrefixesComponent from './stPrefixes.component';
import locationsApi from '../../api/locations/locations';
import removePrefix from '../filters/removePrefix';

let stPrefixesModule = angular.module('stPrefixes', [
    locationsApi,
    removePrefix
])
    .component('stPrefixes', stPrefixesComponent)
    .name;

export default stPrefixesModule;



// WEBPACK FOOTER //
// ./client/app/common/stPrefixes/stPrefixes.js